import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/blogs/index.tsx");
